import { nip19 } from 'nostr-tools';
import { useNavigate, useParams } from 'react-router-dom';
import { SiteLayout } from '@/components/SiteLayout';
import { TrustSearch } from '@/components/TrustSearch';
import { WotReportSection } from '@/components/WotReportSection';
import NotFound from './NotFound';

/**
 * Trust reports are addressable by any NIP-19 profile identifier:
 * `/<npub>` and `/<nprofile>` render that identity's web-of-trust report.
 * Notes, events, and addressable events are not supported by this tool.
 */
export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();
  const navigate = useNavigate();

  if (!identifier) {
    return <NotFound />;
  }

  let pubkey: string | null = null;
  try {
    const decoded = nip19.decode(identifier);
    if (decoded.type === 'npub') {
      pubkey = decoded.data;
    } else if (decoded.type === 'nprofile') {
      pubkey = decoded.data.pubkey;
    }
  } catch {
    pubkey = null;
  }

  if (!pubkey) {
    return <NotFound />;
  }

  return (
    <SiteLayout>
      <div className="container py-10 sm:py-14">
        <div className="mx-auto mb-10 max-w-2xl">
          <TrustSearch
            onAnalyze={(_pk, npub) => navigate(`/${npub}`)}
          />
        </div>
        <WotReportSection pubkey={pubkey} />
      </div>
    </SiteLayout>
  );
}
